module.exports = __webpack_public_path__ + "static/img-oscar-ba7f38ae500c4ba78a94f5dbbd7bc652.png";